import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactBanner() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-red-600">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <div>
          <h2
            className="text-3xl md:text-4xl font-black text-white leading-tight mb-2"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {t('banner_title')}
          </h2>
          <p className="text-red-100 text-base">{t('banner_subtitle')}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
          <a
            href="tel:+18193031365"
            className="px-7 py-3 rounded-full bg-white text-red-600 font-semibold text-sm hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-line" />
            +1 (819) 303-1365
          </a>
          <Link
            to="/contact"
            className="px-7 py-3 rounded-full border-2 border-white text-white font-semibold text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('banner_send')}
          </Link>
        </div>
      </div>
    </section>
  );
}
